import React, {Component, Fragment} from 'react';
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import {number_format} from "../../../utils/formatter";
import {NavLink} from 'react-router-dom'
import moment from 'moment';
import If from "../../common/control/If";
import RetryView from "./RetryView";
import Loading from "../../common/Loading";
import {addPrefix} from "../../../utils/UriUtil";

class CountNavigator extends Component {

  constructor(props) {
    super(props);
    this.state = {
      today: 0,
      yesterday: 0,
      total: 0,
      initialized: InitStatus.INIT_READY
    }
  }

  componentDidMount() {
    this.getCountInfo();
  }

  getCountInfo = () => {
    const {dispatch} = this.props;
        this.setState({initialized: InitStatus.INIT_DOING}, ()=> {

        fetch(addPrefix(`/manage/statistics/blog/count.json`), {
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            retries: 2,
            retryDelay: 300,
            retryOn: [500],
        })
            .then(jsonResponseHandler(dispatch))
            .then(res => res.json())
            .then(res => {
          const data = res.data;      if (data && data.result) {
                    const {today, yesterday, total} = data.result;
                    this.setState({
                        initialized: InitStatus.INIT_SUCCESS,
                        today: today,
                        yesterday: yesterday,
                        total: total,
                    });

            this.props.handleSetCountNavigatorLastUpdateTime(moment(data.lastUpdateTime).format("YYYY-MM-DD HH:mm"));
                }
            })
            .catch(e => {
                console.log('error:', e);
                this.setState({initialized: InitStatus.INIT_FAIL})
                ;

            })
        });
    };


  render() {
    const {today, yesterday, total, initialized} = this.state;
    const useLinkBlogStatistics = (this.props.hasOwnProperty('useLinkBlogStatistics') && this.props.useLinkBlogStatistics);
    const {isDoing, isFail, isSuccess} = InitStatus.init(initialized, null);

    return (
      <div className="box_blog box_visitor">

        <If condition={isFail}>
          <RetryView retryCallback={this.getCountInfo}/>
        </If>

        <If condition={!isFail}>
          <Fragment>
            <dl className="count_visitor">
              <dt>오늘 방문수</dt>
              <dd>
                <If condition={isDoing}><Loading/></If>
                <If condition={!isDoing}>{number_format(today)}</If>
              </dd>
            </dl>
            <dl className="count_visitor">
              <dt>어제 방문수</dt>
              <dd>
                <If condition={isDoing}><Loading/></If>
                <If condition={!isDoing}>{number_format(yesterday)}</If>
              </dd>
            </dl>
            <dl className="count_visitor">
              <dt>누적 방문수</dt>
              <dd>
                <If condition={isDoing}><Loading/></If>
                <If condition={!isDoing}>{number_format(total)}</If>
              </dd>
            </dl>

            <If condition={useLinkBlogStatistics}>
              <NavLink activeClassName="on" className="btn_post" to="/statistics/blog">방문 통계 <span className="ico_blog ico_statistic"></span></NavLink>
            </If>
          </Fragment>
        </If>
      </div>
    );
  }
}

export default CountNavigator;
